import script from "./_Cadastro.vue?vue&type=script&lang=ts"
export * from "./_Cadastro.vue?vue&type=script&lang=ts"

export default script